import { render, staticRenderFns } from "./describe.vue?vue&type=template&id=3712f580&scoped=true"
import script from "./describe.vue?vue&type=script&lang=js"
export * from "./describe.vue?vue&type=script&lang=js"
import style0 from "./describe.vue?vue&type=style&index=0&id=3712f580&prod&scoped=true&lang=css"
import style1 from "./describe.vue?vue&type=style&index=1&id=3712f580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712f580",
  null
  
)

export default component.exports